import React from 'react';
import PropTypes from 'prop-types';

import ListItem from './Shared/ListItem';
import { RadioContext } from './ItemRadioGroup';
import ReplaceableComponents from '~/components/higher-order/ReplaceableComponents';

export const components = {
  ListItem,
};

@ReplaceableComponents(components)
export default class DropdownMenuItemRadio extends React.Component {
  render() {
    return <RadioContext.Consumer>{this.renderValue}</RadioContext.Consumer>;
  }

  renderValue = ({ checkedIndex, check }) => {
    const { index, components, ...props } = this.props;

    const active = checkedIndex === index;
    const { ListItem } = components;

    return (
      <ListItem
        {...props}
        onClick={this.handleItemClick(check)}
        active={active}
      />
    );
  };

  handleItemClick = (check) => () => {
    const { index, disabled = false } = this.props;

    if (disabled) {
      return;
    }

    check(index);
  };
}

DropdownMenuItemRadio.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.any.isRequired,
  className: PropTypes.string,
};
